export default {
    path : "land-item-sea",
    name : "land-item-sea",
    meta : {
        title : "项目公海"
    },
    component: () => import('@/pages/land/sea/Index'),
    redirect: {
        name : "land-item-sea-whole"
    },
    children: [
        {
            path: 'all',
            name: 'land-item-sea-whole',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'land-item-sea-recent',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'land-item-sea-atme',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'land-item-sea-meat',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'land-item-sea-reply',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'land-item-sea-search',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/land/seaitem/index.js